import { oc } from "ts-optchain";

import { mapGetters } from "vuex";

import {ObjectUtil} from "@/services";

import { IShoppingCartContext } from "../../Types";

export default {
  name: "CartPromos",

  props: {
    context: {
      type: Object,
      default: () => {
        return ObjectUtil.createInstance<IShoppingCartContext>();
      }
    }
  },

  computed: {
    ...mapGetters([
      "getContentItem"
    ]),

    promoMessages() {
      return oc(this.context as IShoppingCartContext).cartData.PromotionMessages([]);
    }
  },
}
